import { render, staticRenderFns } from "./CustomersLoginLayout.vue?vue&type=template&id=b50101e8&"
import script from "./CustomersLoginLayout.vue?vue&type=script&lang=js&"
export * from "./CustomersLoginLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports